export const MIN_HIGHLIGHT_LENGTH_MS = 5_000;

export const MAX_HIGHLIGHT_LENGTH_MS = 600_000;

export function formatTime(milliseconds: number): string {
  const seconds = Math.round(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = String(seconds - minutes * 60);

  return `${minutes}:${remainingSeconds.padStart(2, '0')}`;
}

export function parseFormattedTime(formattedTime: string): number {
  const [minutes, seconds] = formattedTime.split(':').map(Number); // mm:ss
  const minutesToMilliseconds = minutes * 60 * 1000;
  const secondsToMilliseconds = seconds * 1000;

  return minutesToMilliseconds + secondsToMilliseconds;
}

interface HighlightTime {
  start: number;
  end: number;
  marker: number;
}

type ValidationError =
  | 'START_EXCEEDS_MARKER'
  | 'END_EXCEEDS_MARKER'
  | 'TOO_SHORT'
  | 'TOO_LONG'
  | null;

export function validateNewHighlightTime({
  newHighlightTime: { start, end, marker },
}: {
  newHighlightTime: HighlightTime;
}): ValidationError {
  if (start >= marker) {
    return 'START_EXCEEDS_MARKER';
  }

  if (end <= marker) {
    return 'END_EXCEEDS_MARKER';
  }

  if (end - start < MIN_HIGHLIGHT_LENGTH_MS) {
    return 'TOO_SHORT';
  }

  if (end - start > MAX_HIGHLIGHT_LENGTH_MS) {
    return 'TOO_LONG';
  }

  return null;
}
